import axios from "axios";
import i18n from "../../../i18n";

import { getClaims } from "../../../modules/login";
import { DailyListKeys } from "../LCF401/DailyEntries/Constants";
import { HttpCodes } from "../../../modules/constants";

//Constants
const FETCHING_ENTRIES = "FETCHING_ENTRIES";
const FETCHING_ENTRIES_ERROR = "FETCHING_ENTRIES_ERROR";
const SET_DAY_ENTRIES = "SET_DAY_ENTRIES";
const SET_YESTERDAY_ENTRIES = "SET_YESTERDAY_ENTRIES";
const SET_DAY_BEFORE_ENTRIES = "SET_DAY_BEFORE_ENTRIES";
const COMPLETING_DAY = "COMPLETING_DAY";
const SET_DAY_COMPLETED = "SET_DAY_COMPLETED";
const LOGOUT = "LOGOUT";
const SET_DAILY_TARGETS = "SET_DAILY_TARGETS";

//Acessors
const getYesterdayEntries = (state) => state?.yesterdayEntries;
const getDayBeforeEntries = (state) => state?.dayBeforeEntries;
const getTodayEntries = (state) => state?.todayEntries;
const getIsLoadingEntries = (state) => state?.loadingEntries;
const getLoadingEntriesError = (state) => state?.loadingEntriesError;
const getIsCompletingDay = (state) => state?.completingDay;
const getDayCompleted = (state) => state?.dayCompleted;
const getStudies = (state) => state?.loginReducer?.studies;
const getDailyTargets = (state) => state?.dailyTargets;

const canCompleteDay = (state) =>
  getClaims(state, "mealLog.completeDay.canComplete");
const canViewMacronutrients = (state) =>
  getClaims(state, "mealLog.macronutrients.canView");
const canAddMeal = (state) => getClaims(state, "mealLog.canCreate");
const canEditMeal = (state) => getClaims(state, "mealLog.canEdit");

//Default state
const initialState = {
  dayBeforeEntries: null,
  yesterdayEntries: null,
  todayEntries: null,
  loadingEntries: false,
  loadingEntriesError: false,
  completingDay: false,
  dayCompleted: false,
  studies: null,
  dailyTargets: null,
};

export const dailyEntries = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_ENTRIES: {
      return Object.assign({}, state, {
        loadingEntries: true,
      });
    }
    case FETCHING_ENTRIES_ERROR: {
      return Object.assign({}, state, {
        loadingEntries: false,
        loadingEntriesError: true,
      });
    }
    case SET_YESTERDAY_ENTRIES: {
      const { entries } = action;
      return Object.assign({}, state, {
        yesterdayEntries: entries,
        loadingEntries: false,
        loadingEntriesError: false,
      });
    }
    case SET_DAY_BEFORE_ENTRIES: {
      const { entries } = action;
      return Object.assign({}, state, {
        dayBeforeEntries: entries,
        loadingEntries: false,
        loadingEntriesError: false,
      });
    }
    case SET_DAY_ENTRIES: {
      const { entries } = action;
      return Object.assign({}, state, {
        todayEntries: entries,
        loadingEntries: false,
        loadingEntriesError: false,
      });
    }
    case COMPLETING_DAY: {
      return Object.assign({}, state, {
        completingDay: true,
      });
    }
    case SET_DAY_COMPLETED: {
      return Object.assign({}, state, {
        dayCompleted: true,
        completingDay: false,
      });
    }
    case SET_DAILY_TARGETS: {
      const { dailyTargets } = action;
      return Object.assign({}, state, {
        dailyTargets: dailyTargets,
      });
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

//Mutators
const fetchEntries = (date) => (dispatch) => {
  const params = {
    StartDate: date.date?.format("YYYY/MM/DDT00:00:00"),
    EndDate: date.date?.format("YYYY/MM/DDT23:59:59"),
  };
  dispatch({ type: FETCHING_ENTRIES });
  return axios
    .get(`/api/diet/meals/`, { params })
    .then(({ data }) => {
      dispatch({ type: SET_DAILY_TARGETS, dailyTargets: data?.dailyTargets });

      if (date.key === DailyListKeys.dayBeforeListName) {
        dispatch({ type: SET_DAY_BEFORE_ENTRIES, entries: data });
      } else if (date.key === DailyListKeys.yesterdayListName) {
        dispatch({ type: SET_YESTERDAY_ENTRIES, entries: data });
      } else {
        dispatch({ type: SET_DAY_ENTRIES, entries: data });
      }
    })
    .catch(() => {
      dispatch({ type: FETCHING_ENTRIES_ERROR });
    });
};

const completeDay = (formData) => async (dispatch) => {
  dispatch({ type: COMPLETING_DAY, completingDay: true });
  return axios
    .post(`/api/diet/meal/complete`, formData)
    .then(() => {
      dispatch({ type: SET_DAY_COMPLETED, dayCompleted: true });
      return Promise.resolve(i18n.t("appText.dietDiary.completeDay.success"));
    })
    .catch((e) => {
      if (e?.response?.status === HttpCodes.CONFLICT) {
        return Promise.reject(i18n.t("errorText.dietDiary.completeDay.409"));
      }

      return Promise.reject(i18n.t("errorText.dietDiary.completeDay"));
    });
};

export const mapStateToProps = (state) => {
  return {
    dayBeforeEntries: getDayBeforeEntries(state),
    yesterdayEntries: getYesterdayEntries(state),
    todayEntries: getTodayEntries(state),
    loadingEntries: getIsLoadingEntries(state),
    loadingEntriesError: getLoadingEntriesError(state),
    completingDay: getIsCompletingDay(state),
    dayCompleted: getDayCompleted(state),
    studies: getStudies(state),
    dailyTargets: getDailyTargets(state),
    canCompleteDay: canCompleteDay(state),
    canViewMacronutrients: canViewMacronutrients(state),
    canAddMeal: canAddMeal(state),
    canEditMeal: canEditMeal(state),
  };
};

export const mapDispatchToProps = {
  fetchEntries,
  completeDay,
};
